import styled from 'styled-components';

export const StepperWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MiniStepperWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: center;

  @media (min-width: 767px) {
    display: none;
  }
`;

export const TitleForm = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutralLow};
  text-align: center;
  margin-bottom: 16px;

  @media screen and (max-width: 767px) {
    margin-bottom: 8px !important;
    font-size: 20px;
    line-height: 28px;
  }
`;
